(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      // The theme's sticky class controls positioning, not the background color.
      this.header.classList.remove('nou-header-ready');
      this.header.classList.toggle('shopify-section-header-sticky', this.headerIsAlwaysSticky);

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);

      // Apply the actual scroll state immediately, including a restored position.
      this.onResize();
      this.onScroll();

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('pageshow', this.onScrollHandler);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResizeHandler);
        this.resizeObserver.observe(this.header);
      }

      // Allow fades only after the initial background has been painted.
      this.readyFrame = requestAnimationFrame(() => {
        this.readyFrame = requestAnimationFrame(() => {
          this.header.classList.add('nou-header-ready');
        });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('pageshow', this.onScrollHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      cancelAnimationFrame(this.readyFrame);
    }

    onResize() {
      this.setHeaderHeight();
      this.updateDrawerPosition();
    }

    updateDrawerPosition() {
      const drawer = this.querySelector('#menu-drawer');
      if (drawer) {
        drawer.style.top = `${this.header.getBoundingClientRect().bottom}px`;
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    onScroll() {
      const scrollTop = Math.max(0, window.scrollY || document.documentElement.scrollTop);
      const isScrolled = scrollTop > 0;

      // Do not change the header's positioning when the page reaches the top.
      this.header.classList.toggle('nou-header-scrolled', isScrolled);
      this.header.classList.toggle('shopify-section-header-transparent', !isScrolled);

      this.updateDrawerPosition();
      this.currentScrollTop = scrollTop;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
